import { Report } from "core/types/report.types";

export const transformReport = (data: any): Report => ({
  createdAt: data?.created_at,
  fileId: data?.file_id,
  path: data?.path,
  type: data?.type,
  userId: data?.user_id,
});

export const transformReportList = (data: any): Report[] =>
  data?.map((result: any) => transformReport(result));
